import React, { useEffect, useRef, useState } from "react";
import { Input, Alert, Button, Form } from "@intech/web-ui";
import { Link, useHistory } from "react-router-dom";
import { Session } from "@intech/react-service";

import { AuthService, VersionService } from "@services";
import { LoginEntidade } from "@entidades";

import packageJson from "../../../package.json";
import { BaseAuth } from "./Base";

import "./index.scss";
import { FaArrowRight, FaEye, FaEyeSlash } from "react-icons/fa";
// import { criarAcesso } from "@helpers/Log";

export const Login: React.FC = () => {
  const history = useHistory();

  const form = useRef<Form>(null);

  const [VersaoAPI, setVersaoAPI] = useState<string>("");
  const [cpf, setCpf] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [Erros, setErros] = useState(null);

  useEffect(() => {
    (async () => {
      await Session.clear();
      const versaoAPI = await VersionService.Buscar();
      setVersaoAPI(versaoAPI);
    })();
  }, []);

  async function onSubmit() {
    setErros("");

    try {
      const erros = await form?.current?.validate();

      if (erros) {
        setErros(erros);
        return;
      }

      const user: LoginEntidade = {
        Cpf: cpf,
        Senha: senha,
        Origem: 1
      };

      const login = await AuthService.Login(user);

      await Session.setToken(login.AccessToken);
      localStorage.setItem("pensionista", login.Pensionista.toString());

      // await criarAcesso(cpf, "PORTAL");

      // const NaoParticipante = await UsuarioService.VerificarNaoParticipante();

      // if (NaoParticipante && login.Admin) {
      //   history.push("/trocarSenha");
      //   return;
      // }

      const matriculas = await AuthService.BuscarContratos();

      if (matriculas.length > 1) {
        history.push("/selecionarContrato");
      } else {
        history.push("/");
      }
    } catch (e) {
      const err: any = e;
      const message = err.response ? err.response.data : err;
      setErros(message);
    }
  }

  return (
    <BaseAuth>
      <h5>
        <b>Área de Acesso Restrito</b>
        <br />
        <small>
          Para maiores informações, entre em contato com a{" "}
          <a target="_blank" rel="noopener noreferrer" href="https://regiusprev.com.br/">
            Regius
          </a>
        </small>
        <br />
        <br />
      </h5>

      <Form ref={form}>
        <Input value={cpf} max={11} onChange={setCpf} placeholder="CPF (somente números)" />

        <Input
          value={senha}
          onChange={setSenha}
          placeholder={"Senha"}
          type={senhaVisivel ? "text" : "password"}
          icon={senhaVisivel ? <FaEyeSlash /> : <FaEye />}
          buttonLeft={false}
          group
          onButtonClick={() => setSenhaVisivel((old) => !old)}
        />

        <Button title={"Entrar"} type={"primary"} icon={<FaArrowRight />} usesLoading loadingText="Carregando..." block submit onClick={onSubmit} />

        <div className={"form-group text-center"}>
          <Link className={"btn btn-link"} to={"/esqueciSenha"}>
            Esqueci Minha Senha / Primeiro Acesso
          </Link>
        </div>

        <Alert type={"danger"}>{Erros}</Alert>
      </Form>

      <br />
      <br />
      <div className="text-center">Versão Portal {packageJson.version}</div>
      <div className="text-center">Versão API {VersaoAPI}</div>
    </BaseAuth>
  );
};
